import type { Picker } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

import type { Step } from '../components/CustomizationFunnel/utils/types'

export function getGradeImage(
  gradeStep: Step | Picker,
  gradeId: number,
  type: 'Screen' | 'Body',
) {
  return (
    gradeStep.sideContentV2?.content
      ?.find((item) => item.grade === gradeId)
      ?.items?.find((item) => item.sectionId === type)?.imageUrl || ''
  )
}
